import {
  Row,
  Col,
  Typography,
  Button,
  Modal
} from "antd";
import React, { useState, forwardRef, useImperativeHandle } from "react";
import "../EmailSettings/EmailSettings.css";
const EmailSettingsKVP = forwardRef(( props, ref) => {

    useImperativeHandle(ref, () => ({
        data() {
            return tableData
        },
        setData(data) {
            setTableData(data)
        }
    }));

const initialConfigurationData = props.configurationData
function clonedConfigurationItems() { 
    if (!initialConfigurationData || !initialConfigurationData.initialData || initialConfigurationData.initialData.length === 0) {
        return []
    }
    return JSON.parse(JSON.stringify(initialConfigurationData.initialData)) 
};


const [tableData, setTableData] = useState(clonedConfigurationItems);
const [mode, setMode] = useState(initialConfigurationData.mode);
const [containerId, setContainerId] = useState(initialConfigurationData.containerId);
const [hasChanges, setHasChanges] = useState(false)
const [itemToDelete, setItemToDelete] = useState({});
const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] = useState(false);
const [copiedItemId, setCopiedItemId] = useState(0);

const generateUniqueId = () => { return generateUniqueIdWithParameters(10, 1, 100) }

const generateUniqueIdWithParameters = (length, recursionIteration, recursionLimit) => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ123456789';
  let uniqueId = '';
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    uniqueId += characters.charAt(randomIndex);
  }

  if (tableData.find(x => x.id === uniqueId)) {
    if (recursionIteration >= recursionLimit) {
        return "UNABLE-TO-GENERATE-UNIQUE-ID"
    }
    return generateUniqueIdWithParameters(length, recursionIteration++, recursionLimit)
  }
  return uniqueId;
}

const updateConfigurationItemName = async (data, id) => { 
    updateConfigurationItemNameOrValue("name", data, id)
}
const updateConfigurationItemValue = async (data, id) => { 
    updateConfigurationItemNameOrValue("value", data, id)
}

const updateConfigurationItemNameOrValue = async (type, data, id) => { 
    let configurationItemToUpdate = tableData.find(x => x.id === id)
    configurationItemToUpdate[type] = data;
    detectAndReportChanges(tableData)
}

const detectAndReportChanges = (data) => {
    let hasChanges = JSON.stringify(data.filter(x => x.name !== "" && x.value !== "")) !== JSON.stringify(initialConfigurationData.initialData)
    setHasChanges(hasChanges)
    props.onChange(initialConfigurationData.sectionName, hasChanges)
    console.log(hasChanges)
}

const removeProperty = (item) => {
    if (item.name === "" && item.value ===  "") {
        setTableData(rows => rows.filter(x => x.id !== item.id))
        return
    }

    setItemToDelete(item);
    setShowDeleteConfirmationModal(true)
}

const addProperty = () => {
    setTableData(rows => [...tableData, {id: generateUniqueId(), name: "", value: ""}])
}

const onDeleteClosed = () => {
    setItemToDelete({});
    setShowDeleteConfirmationModal(false)
}
const onDeleteCancel = () => {
    onDeleteClosed()
}
const onDeleteConfirm = () => {
    let filteredTableData = tableData.filter(x => x.id !== itemToDelete.id)
    setTableData(filteredTableData)
    detectAndReportChanges(filteredTableData)
    onDeleteClosed()
}

const DeleteConfirmationModal = () => {
    if (!showDeleteConfirmationModal) return null;

    return (
           <Modal
              className="delete-confimation-modal"
              open={showDeleteConfirmationModal}
              closable={false}
              footer={[
                <Button
                  className="standard-button secondary-orange-button"
                  key="confirm"
                  onClick={() => { onDeleteConfirm() }}>Delete</Button>,
                <Button
                  className="standard-button primary-orange-button"
                  key="stay"
                  type="primary"
                  onClick={() => { onDeleteCancel() }}>Cancel</Button>
            ]}>
            <Row>
                <Col span={24}>
                  <Typography.Title level={5}>
                    Add a new email address?
                  </Typography.Title>
                  <Typography.Text type="secondary">
                    Creating a new email address will delete the current entry. Are you sure you want to continue?
                  </Typography.Text>
                </Col>
              </Row>
        </Modal>
      );

}

const copyTextToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text); //
    return true;
  } catch (err) {
    console.error('Failed to copy text: ', err);
    return false;
  }
};

return (
    <div className="component-container">
        <div className="modals">
            <DeleteConfirmationModal />
        </div>
        { mode.toLowerCase() === "displayonly" && (
            <div className="kvp-config-container" id={containerId}>  
                <div className="configuration-type">{initialConfigurationData.sectionName}</div>
                {tableData.map((item) => (
                    <div key={item.id}>{item.name} : {item.value} 
                        <button className="copy-button" 
                                onClick={() => {
                                    setCopiedItemId(item.id);
                                    copyTextToClipboard(item.value);
                                    setTimeout(() => setCopiedItemId(0), 2000);
                                }}>
                            {copiedItemId === item.id ? 'Copied!' : 'Copy Value'}  
                        </button> 
                    </div>
                ))}
            </div>
        )} 

        { mode.toLowerCase() === "editable" && (
            <div className="kvp-config-container" id={containerId}>  
                <div className="configuration-type">{initialConfigurationData.sectionName}</div>
                <table className="configuration-table">
                    <thead>
                        <tr className="configuration-header-row">
                        <th className="connection-property-name">Property Name</th>
                        <th className="connection-property-value">Property Value</th>
                        <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {tableData.map((item) => 
                            (<tr className="configuration-data-row" key={item.id} id={item.id}>
                                <td className="configuration-key-column">
                                    <input 
                                        type="text" 
                                        className="configuration-input" 
                                        id={"name:" + item.id} 
                                        defaultValue={item.name} 
                                        onChange={(event) => updateConfigurationItemName(event.target.value, item.id)} />
                                </td>
                                <td className="configuration-value-column">
                                    <input 
                                        type="text" 
                                        className="configuration-input" 
                                        id={"value:" + item.id} 
                                        defaultValue={item.value} 
                                        onChange={(event) => updateConfigurationItemValue(event.target.value, item.id)} />
                                </td>
                                <td className="configuration-controls-column">
                                    <span className="delete-configuration-item" onClick={() => removeProperty(item)}>X</span>
                                </td>
                            </tr>)
                        )}
                    </tbody>
                </table>
                <div className="configuration-section-controls">
                    <div className="right-side">
                        <button className="add-property" onClick={addProperty}>Add Property</button>
                        {/* <button className="save-properties" onClick={configurationData.saveCallback}>Save</button> */}
                    </div>
                </div>
            </div> 
        )}
    </div>
  )
})
export default EmailSettingsKVP;